import { Editor, Element, Point, Range, Transforms } from 'slate';

import { WithResetBlockTypeOptions } from './types';

/**
 * When deleting backward at the start of an empty block, reset the block type to a default type.
 */
export const withDeleteStartReset = ({ types, onDefault, onUnwrap }: WithResetBlockTypeOptions) => {
  return <T extends Editor>(editor: T) => {
    const { deleteBackward } = editor;

    // eslint-disable-next-line no-param-reassign
    editor.deleteBackward = (...args) => {
      const { selection } = editor;

      if (!!selection && Range.isCollapsed(selection)) {
        const parent = Editor.above(editor, {
          match: (n) => Element.isElement(n) && types.includes(n.type as string),
        });

        if (parent) {
          const [, parentPath] = parent;
          const parentStart = Editor.start(editor, parentPath);

          if (selection && Point.equals(selection.anchor, parentStart)) {
            Transforms.setNodes(editor, onDefault());

            if (onUnwrap) {
              onUnwrap();
            }

            return;
          }
        }
      }

      deleteBackward(...args);
    };

    return editor;
  };
};
